import {
  SELECT_PROJECT,
  ROLLBACK_PROJECT,
} from 'store/services/project/actionTypes';
import { LOGOUT_USER_SUCCESS } from 'store/services/session/actionTypes';
import * as types from './actionTypes';
import initialState from './initialState';

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case types.GET_INTENT_UTTERANCE_LIST_REQUEST:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: true,
        },
      };
    case types.GET_INTENT_UTTERANCE_LIST_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: false,
          data: action.payload.utterances,
        },
      };
    case types.GET_INTENT_UTTERANCE_LIST_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case types.ADD_INTENT_UTTERANCE_REQUEST:
      return {
        ...state,
        add: {
          ...state.add,
          isLoading: true,
        },
      };
    case types.ADD_INTENT_UTTERANCE_SUCCESS:
      return {
        ...state,
        add: {
          ...state.add,
          isLoading: false,
        },
      };
    case types.ADD_INTENT_UTTERANCE_ERROR:
      return {
        ...state,
        add: {
          ...state.add,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case types.UPDATE_INTENT_UTTERANCE_REQUEST:
      return {
        ...state,
        update: {
          ...state.update,
          isLoading: true,
        },
      };
    case types.UPDATE_INTENT_UTTERANCE_SUCCESS:
      return {
        ...state,
        update: {
          ...state.update,
          isLoading: false,
        },
      };
    case types.UPDATE_INTENT_UTTERANCE_ERROR:
      return {
        ...state,
        update: {
          ...state.update,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case types.DELETE_INTENT_UTTERANCE_REQUEST:
      return {
        ...state,
        delete: {
          ...state.delete,
          isLoading: true,
        },
      };
    case types.DELETE_INTENT_UTTERANCE_SUCCESS:
      return {
        ...state,
        delete: {
          ...state.delete,
          isLoading: false,
        },
      };
    case types.DELETE_INTENT_UTTERANCE_ERROR:
      return {
        ...state,
        delete: {
          ...state.delete,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case LOGOUT_USER_SUCCESS:
    case SELECT_PROJECT:
    case ROLLBACK_PROJECT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
